import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingBundle } from './types';

export function useBillingBundles() {
  const { data, error, isLoading, mutate } = useSWR<TBillingBundle[]>(
    'commenda-billing/catalog/bundles',
    SWRFetcher({ method: 'GET' })
  );

  return { bundles: data ?? [], error, isLoading, mutate };
}
